import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {_GridService} from "../../../ng1-services/grid.service";
import {jqxGridComponent} from "../../../../assets/jqwidgets-ts/angular_jqxgrid";
import {Grid} from "../../../interfaces/grid.interface";
import {Observable} from "rxjs/Observable";
import {_OrganizationHolidayService} from "../../../services/organization.holiday.service";

declare var $: any, dump: any;

@Component({
  selector: 'minimum-order-quantity',
  templateUrl: './organization-holidays.component.html',
  styleUrls: ['./organization-holidays.component.css'],
})

export class OrganizationHolidayBranch implements OnInit, OnDestroy {

  private $observable: Observable<any>;
  private subscription: any;

  @ViewChild('organizationHolidayGrid') organizationHolidayGrid: jqxGridComponent;
  private organizationHolidaySettings: Grid;

  constructor (private titleService: Title, private holidayService: _OrganizationHolidayService, private gridservice: _GridService) {}

  ngOnInit(){
    this.titleService.setTitle("WiseRisk | Organization Holiday Settings");
    this.getOrganizationHolidays();
  }

  getOrganizationHolidays(){
    this.organizationHolidaySettings = null;
    if(this.subscription){
      this.subscription.unsubscribe();
    }
    this.$observable = this.holidayService.getOrganizationHolidays();
    this.subscription = this.$observable.subscribe(
      result => this.loadOrganizationHolidays(result)
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  loadOrganizationHolidays(minimumOrderQuantities) {
    let msgContainer = "organizationHolidayMsg";
    var source = {
      datatype: 'json',
      localdata: minimumOrderQuantities,
      datafields: [
        {
          name: 'organizationHolidayId',
          type: 'string'
        }, {
          name: 'organizationId',
          type: 'string'
        }, {
          name: 'holiday',
          type: 'string',
          format: 'yyyy-MM-dd'
        }, {
          name: 'displayName',
          type: 'string'
        }
      ],
      updaterow: (rowid, rowdata, commit) => {
        if (rowdata.rowId < 1) {
          this.holidayService.createOrganizationHoliday(rowdata).subscribe(data => {
            this.gridservice.SuccessMsg(msgContainer, 'Organization Holiday Added');
            this.getOrganizationHolidays();
          }, data => {
            this.gridservice.ErrorMsg(msgContainer, data);
          });
        } else {
          this.holidayService.updateOrganizationHoliday(rowdata).subscribe(data => {
            this.gridservice.SuccessMsg(msgContainer, 'Organization Holiday Updated');
            this.getOrganizationHolidays();
          }, data => {
            this.gridservice.ErrorMsg(msgContainer, data);
          });
        }
      },
      deleterow: (rowdata) => {
        this.holidayService.deleteOrganizationHoliday(rowdata.organizationHolidayId).subscribe(data => {
          this.gridservice.SuccessMsg(msgContainer, 'Organization Holiday Deleted');
          this.getOrganizationHolidays();
        }, data => {
          this.gridservice.ErrorMsg(msgContainer, data);
        });
      },
      refresh: () => {
        this.getOrganizationHolidays();
      },
      getGrid: () => {
        return this.organizationHolidayGrid;
      }
    };
    this.organizationHolidaySettings = {
      source: source,
      dataAdapter: new $.jqx.dataAdapter(source),
      columns: [
        {
          text : 'Holiday',
          columntype : 'textbox',
          datafield : 'displayName',
          width : '150'
        }, {
          text: 'Date',
          columntype: 'datetimeinput',
          datafield: 'holiday',
          cellsformat: 'yyyy-MM-dd',
          createeditor: (row, cellvalue, editor) => {
            editor.jqxDateTimeInput({showTimeButton: false, showCalendarButton: true, formatString: 'yyyy-MM-dd'});
          },
          initeditor: (row, cellvalue, editor, celltext, cellwidth, cellheight) => {
            if(cellvalue){
              var dateVal = new Date(Date.parse(cellvalue));
              dateVal.setTime(dateVal.getTime() + dateVal.getTimezoneOffset()*60*1000);
              editor.jqxDateTimeInput('setDate',  dateVal);
            }
          }
        }
      ],
      renderstatusbar: (statusbar: any) => {
        this.gridservice.RenderStatusBar(statusbar, source);
      }
    };
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/settings/holidays/organization.holidays.component.ts